export const ChatIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none">
    <rect width={32} height={32} fill="#F0F2FF" rx={5.469} />
    <path
      fill="#4B22F4"
      fillRule="evenodd"
      d="M5 7.73c0-1.106.894-2 2-2h18c1.106 0 2 .894 2 2v13.5c0 1.106-.894 2-2 2H14.69l-4.945 2.78A.5.5 0 0 1 9 25.576V23.23H7c-1.106 0-2-.894-2-2V7.73Zm2-1c-.554 0-1 .446-1 1v13.5c0 .554.446 1 1 1h2.5a.5.5 0 0 1 .5.5v1.99l4.315-2.426a.501.501 0 0 1 .245-.064H25c.554 0 1-.446 1-1V7.73c0-.554-.446-1-1-1H7Z"
      clipRule="evenodd"
    />
    <path
      fill="#4B22F4"
      fillRule="evenodd"
      d="M8.5 11.73a.5.5 0 0 1 .5-.5h14a.5.5 0 1 1 0 1H9a.5.5 0 0 1-.5-.5ZM8.5 14.73a.5.5 0 0 1 .5-.5h14a.5.5 0 1 1 0 1H9a.5.5 0 0 1-.5-.5ZM8.5 17.73a.5.5 0 0 1 .5-.5h12a.5.5 0 1 1 0 1H9a.5.5 0 0 1-.5-.5Z"
      clipRule="evenodd"
    />
  </svg>
);

export const UserIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none">
    <rect width={31.533} height={31.533} fill="#F0F2FF" rx={5.469} />
    <g fill="#4B22F4" fillRule="evenodd">
      <path d="M12.09 7.432a3.187 3.187 0 1 0 0 6.374 3.187 3.187 0 0 0 0-6.374ZM7.921 10.62a4.167 4.167 0 1 1 8.335 0 4.167 4.167 0 0 1-8.335 0ZM21.65 7.432a1.961 1.961 0 1 0 0 3.922 1.961 1.961 0 0 0 0-3.922ZM18.71 9.393a2.942 2.942 0 1 1 5.883 0 2.942 2.942 0 0 1-5.883 0ZM4 23.856a8.09 8.09 0 0 1 16.179 0v.245c0 .271-.22.49-.49.49H4.49a.49.49 0 0 1-.49-.49v-.245Zm.985-.245h14.21a7.11 7.11 0 0 0-14.21 0Z" />
      <path d="M21.65 14.296a4.902 4.902 0 0 0-4.697 3.498.49.49 0 1 1-.94-.28 5.882 5.882 0 0 1 5.637-4.199 5.88 5.88 0 0 1 5.883 5.884v.49c0 .27-.22.49-.49.49h-8.6a.49.49 0 1 1 0-.98h8.11a4.9 4.9 0 0 0-4.903-4.903Z" />
    </g>
  </svg>
);
